import { SCREEN_NAME } from 'constants/index';
import {
  sendScreenEvent,
  sendUIEvent,
  sendTrackEvent,
} from 'services/analytics';

const ANALYTICS_SOURCE = SCREEN_NAME.EDIT_PROFILE;

// https://data-portal.internal.atlassian.com/analytics/registry/71734
const trackEditProfileScreenView = (isPersonalView: boolean) => {
  sendScreenEvent({
    screenName: ANALYTICS_SOURCE,
    isPersonalView,
  });
};

//https://data-portal.internal.atlassian.com/analytics/registry/71746
const trackBackToProfileClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: ANALYTICS_SOURCE,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'backToProfile',
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71747
const trackCloseEditProfileClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: ANALYTICS_SOURCE,
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'closeEditProfile',
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71748
const trackSaveEditProfileChangesClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: ANALYTICS_SOURCE,
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'saveEditProfileChanges',
    isPersonalView,
  });
};

type ProfileAttributes = {
  hasBio: boolean;
  hasCompany: boolean;
  hasLinkedinUrl: boolean;
  hasLocation: boolean;
  hasRole: boolean;
  hasWebsiteUrl: boolean;
  hasXUrl: boolean;
  hasYoutubeUrl: boolean;
  productCount: number;
};

// https://data-portal.internal.atlassian.com/analytics/registry/71743
const trackProfileUpdated = (
  attributes: ProfileAttributes,
  isPersonalView: boolean,
  duration?: number,
) => {
  sendTrackEvent({
    source: ANALYTICS_SOURCE,
    action: 'updated',
    actionSubject: 'profile',
    attributes: {
      ...attributes,
      ...(duration !== undefined && { duration }),
    },
    isPersonalView,
  });
};

export {
  trackEditProfileScreenView,
  trackBackToProfileClick,
  trackCloseEditProfileClick,
  trackSaveEditProfileChangesClick,
  trackProfileUpdated,
};
